import React, { useState, useEffect } from "react";
import {
  ActionBarUserComp,
  DatatableUsers,
  CreateUserComp,
  EditUserComp,
  DetailUserComp,
  MappingBabUserComp
} from "../../components";
import Modal from "react-bootstrap/Modal";
import axios from "../../library/axios";
import { MySwal } from "../../library/swal";
import { useLocation } from "react-router-dom";
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";

const UsersPage = () => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const [search, setSearch] = useState([]);
  const [filterUsers, setFilterUsers] = useState([]);
  const [user, setUser] = useState({});
  const [users, setUsers] = useState([]);
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowUpdate, setLgShowUpdate] = useState(false);
  const [lgShowDetail, setLgShowDetail] = useState(false);
  const [lgShowMappingChapter, setLgShowMappingChapter] = useState(false);
  // const [lgShowUpdateGroup, setlgShowUpdateGroup] = useState(false);


  const handleMappingBab = (user) => {
    setUser(user);
    setLgShowMappingChapter(true);
  };

  const handleDetail = (user) => {
    setUser(user);
    setLgShowDetail(true);
  };

  const fetchData = async () => {
    try {
      const options = {
        url: `/users/list`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setUsers(data);
      setFilterUsers(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: "info",
          title: "Oops, Unauthorize!",
          text: "Session anda habis, Silahkan login kembali.",
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname === mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: "info",
            title: "Oops, No Access!",
            text: "Anda tidak memiliki akses di halaman ini.",
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleHapus = (id) => {
    MySwal.fire({
      title: "Apa anda yakin menghapus data ini?",
      text: "Anda tidak akan dapat mengembalikan data ini!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Hapus Data!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/users/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: "Berhasil menonaktifkan User!",
              });
              // return false
              setTimeout(() => {
                fetchData();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response?.data);
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  useEffect(() => {
    fetchData();
    fetchLoginStatus();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleEdit = (user) => {
    setUser(user);
    setLgShowUpdate(true);
  };

  // const handleEditGroup = (user) => {
  //   setUser(user);
  //   // setlgShowUpdateGroup(true);
  // };

  useEffect(() => {
    const result = users.filter((item) => {
      let fullname = item.namaLengkap;
      let username = item.username;
      return fullname
        .concat(username)
        .toLowerCase()
        .match(search.toString().toLowerCase());
    });
    setFilterUsers(result);
    // eslint-disable-next-line
  }, [search]);

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Halaman Daftar Pengguna
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            <ActionBarUserComp showFormAdd={() => setLgShowAdd(true)} />
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <DatatableUsers
                      users={filterUsers}
                      search={search}
                      handleChangeSearch={handleChangeSearch}
                      handleEdit={handleEdit}
                      handleHapus={handleHapus}
                      handleDetail={handleDetail}
                      handleMappingBab={handleMappingBab}
                    />
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}

      <Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Pengguna</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateUserComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchData()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdate}
        onHide={() => setLgShowUpdate(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Pengguna</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditUserComp
            user={user}
            close={() => setLgShowUpdate(false)}
            fetch={() => fetchData()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowDetail}
        onHide={() => setLgShowDetail(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Detail Info Pengguna</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailUserComp
            user={user}
            close={() => setLgShowDetail(false)}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowMappingChapter}
        onHide={() => setLgShowMappingChapter(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Mapping Bab: {user.namaLengkap}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MappingBabUserComp
            user={user}
            close={() => setLgShowMappingChapter(false)}
            fetch={() => fetchData()}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UsersPage;
